import Application from '@ember/application';

export function initialize(application: Application): void {
  // Initialize error handler if needed
}

export default {
  name: 'error-handler',
  initialize,
};
